import { capitalize, typeNameText } from "@mesketch/i18n";
import type { TypeResult } from "@mesketch/engine";

/** Jméno typu jako text pro titulek a seznam testů. */
export function typeName(texts: Parameters<typeof typeNameText>[0], type: TypeResult | null, locale: string): string | undefined {
  const f = type?.final;
  if (f === null || f === undefined) return undefined;
  const name = typeNameText(texts, f.noun, f.adjective);
  return name === "" ? undefined : capitalize(name, locale);
}
